import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-steps-indicator',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './steps-indicator.component.html',
  styleUrls: ['./steps-indicator.component.scss']
})
export class StepsIndicatorComponent {
  @Input() currentStep: number = 1;
  steps = [1, 2, 3, 4, 5, 6];

  getStepClasses(step: number): string {
    if (this.currentStep > step) {
      return 'step-active';
    } else if (this.currentStep === step) {
      return 'step-active';
    } else {
      return 'step-pending';
    }
  }

  getStepPosition(index: number): string {
    return `${index * 20}%`;
  }
}
